import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        forgotPassword: builder.mutation({
            query: (body) => ({
                url: `admin/forgotPassword`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
    })
})

export const { useForgotPasswordMutation } = Api
